"use strict";
/**
 * Stock Calculation Types
 *
 * Domain types for stock calculation (min/max/optimal).
 * Used by StockCalculationService, ConsumptionAnalysisService, etc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrendType = void 0;
// ============================================================================
// Trend Types
// ============================================================================
/**
 * TrendType - Classification of consumption trend
 *
 * Based on Q/Y ratio (quarterly vs yearly consumption).
 */
var TrendType;
(function (TrendType) {
    /** Growing: Q/Y ratio > GROWTH_THRESHOLD (recent consumption higher than average) */
    TrendType["GROWING"] = "growing";
    /** Stable: ratio between DECLINE_THRESHOLD and GROWTH_THRESHOLD */
    TrendType["STABLE"] = "stable";
    /** Declining: Q/Y ratio < DECLINE_THRESHOLD (recent consumption lower than average) */
    TrendType["DECLINING"] = "declining";
    /** New: Only recent data exists (no historical baseline) */
    TrendType["NEW"] = "new";
    /** No Q4: Has historical data but no recent activity */
    TrendType["NO_RECENT_ACTIVITY"] = "noRecentActivity";
    /** No Activity: No consumption data at all */
    TrendType["NO_ACTIVITY"] = "noActivity";
})(TrendType || (exports.TrendType = TrendType = {}));
